import { MAX_TITLE_LENGTH, MAX_NOTES_LENGTH, MAX_LABEL_LENGTH } from './tasks';

export const DEFAULT_LANGUAGE = 'EN';

export const LANGUAGES_LIST = ['UA', 'EN', 'RU', 'DE'];

export const TEXTS = {
  UA: {
    NIGHT_MODE: 'Нічний режим',
    ADVICE_SETTINGS: 'Не показувати поради',
    TASKS: 'Завдання',
    CALENDAR: 'Календар',
    TASK_LIST: 'Список завдань',
    DELAYED: 'Відкладені',
    ACCOUNT: 'Акаунт',
    CREATE_GLOBAL_TASK: 'Створити ціль',
    TASK: 'Створити завдання',
    NEW_TASK: 'Додайте назву завдання',
    NEW_GOAL: 'Додайте назву цілі',
    RESCHEDULE_ON_DATE: 'Перенести на дату',
    RESCHEDULE: 'Перенести',
    NO_TASK: 'Завдання немає',
    NO_TASKS: 'Завдань немає',
    CONNECT_TO_GOAL: 'Додайте завдання до цілі',
    DISCONNECT_TASK: "Від'єднати завдання",
    NEW_DELAYED_TASK: 'Нове завдання без дати',
    IMPORTANT_TASK: 'Високий пріоритет',
    PRIORITY: 'Пріоритет',
    HIGH_PRIORITY: 'Високий',
    COMMON_PRIORITY: 'Звичайний',
    TYPE: 'Тип',
    REGULAR_TASK: 'Регулярне',
    GLOBAL_TASK: 'Глобальна',
    DELAYED_TASKS: 'Завдання без дати',
    SINGLE_TASK: 'Разове',
    DATE_SINGLE_TASK: 'Дата',
    DATE_AND_TIME_TASK: 'Дата і час',
    TIME_NEED: 'Години',
    TIME: 'Години',
    TIME_NEED_IN_TASK: 'Необхідний час',
    ADD_BUTTON: 'Додати',
    SAVE_BUTTON: 'Зберегти',
    DELETE_BUTTON: 'Видалити',
    CANCEL_BUTTON: 'Відмінити',
    CONFIRM: 'Так',
    DELETE_TASK: 'Видалити завдання',
    RENAME_REGULAR_TASKS: 'Перейменувати усі завдання',
    DAY: 'День',
    HOUR: 'год',
    MINUTE: 'хв',
    WEEK: 'Тиждень',
    WEEK_SHORT: 'тижд',
    MONTH_SHORT: 'м',
    MONTH: 'Місяць',
    YEAR: 'Рік',
    LIST: 'Список',
    NEW_TASK_BUTTON: 'Нове завдання',
    REPEATING_TASK: 'Розклад повторів',
    START_FINISH_TASK: 'Дата початку і завершення завдання',
    START_DATE: 'Початок',
    FINISH_DATE: 'Кінець',
    UA: 'Українська',
    EN: 'Англійска',
    RU: 'Російська',
    DISABLE_TASKS_DONE: 'Приховати виконані завдання',
    GENERAL_INFO_TITLE: 'Основна інформація',
    SETTINGS_TITLE: 'Налаштування',
    LANGUAGE_SELECT: 'Вибрати мову',
    DISABLE_HELP: 'Приховати підказки',
    DISABLE_NEWS: 'Отримувати новини на пошту',
    DELETE_ACCOUNT: 'Видалити акаунт',
    EDIT_PASSWORD: 'Змінити пароль',
    STATISTICS: 'Статистика',
    TASKS_NUMBER: 'Кількість завдань',
    TASK_PLANNED: 'Заплановано',
    STATUS: 'Статус',
    TASKS_DONE: 'Виконано',
    TASK_ALL: 'Усі завдання',
    TASKS_GOAL: 'Цілі',
    TASK_DELAYED: 'Протерміновано',
    STATISTICS_CURRENT_WEEK: 'Статистика за поточний тиждень',
    STATISTICS_LAST_WEEK: 'Продуктивність минулих тижнів',
    INDEX: 'Виконані завдання (%)',
    GLOBAL_TASK_TITLE: 'Глобальні цілі',
    ALL_SIMPLE_TASK_TITLE: 'Усі завдання',
    ACHIEVE_GOAL: 'До завершення цілі залишилося ',
    GOAL_TERM: 'Період досягнення цілі',
    SELECT_GLOBAL_TASK: 'Вибрати ціль:',
    SELECT_LABEL: 'Вибрати ярлик',
    GO_BACK: 'Назад',
    DAYS_TO_END: 'днів',
    GOAL_OVERDUE_TITLE: 'Ціль протермінована на',
    DONE: 'Ціль досягнута',
    TASK_TRANSFERRED_TO_DELAYED: 'Завдання перенесене',
    TASK_CREATED: 'Завдання створене',
    GOAL_CREATED: 'Ціль створена',
    GOAL_DELETED: 'Ціль видалена',
    TASK_DELETED: 'Завдання видалене',
    GOAL_UPDATED: 'Ціль оновлена',
    TASK_UPDATED: 'Завдання оновлене',
    LOG_OUT: 'Вийти',
    GOAL_MET: 'Досягнуті цілі',
    USED: 'з {{taskNumberLimit}} використано',
    TASK_TITLE: 'Назва завдання',
    DATE_PERIOD: 'Дата / період',
    HOURS: 'Години',
    TIME_TO_FINISH: 'Час на виконання',
    ALL_GOALS: 'Усі цілі',
    CREATE_YOUR_DAY: 'Створи свій день',
    DONE_NUMBER_OF: 'Виконано {{tasksDoneNumber}} із {{tasksNumber}} завдань',
    END_DATE_FOR_ACHIEVING_THE_GOAL: 'Виберіть період, впродовж якого ви хочете досягнути ціль',
    CHANGE_END_DATE: 'Змінити кінцеву дату',
    GOAL_WAS_CREATED: 'Ціль була створена',
    RELATED_TASKS: "Зв'язані завдання",
    RELATED_TASKS_ON_CALENDAR: 'Календар завдань',
    GOAL_OVERDUE_FOR: 'Ціль протермінована на {{daysNumber}} днів',
    GOAL_TODAY: 'Завершення цілі сьогодні',
    LEFT_TO_COMPLETE: 'До завершення залишилося {{daysNumberLeft}} днів',
    TASKS_DONE_ALL: 'Зроблено / усі',
    ALL_TASK_DONE_TEXT: 'Всі завдання зроблені',
    VISIT_EMAIL: 'Будь ласка, превірте пошту',
    NO_DELAYED_TASKS: 'Тут поки що пусто',
    CREATE_FIRST_DELAYED_TASK: 'Додай завдання',
    CREATE_WEEK_TITLE: 'Сплануй продуктивний тиждень',
    CREATE_MONTH_TITLE: 'Завдань на цей місяць поки нема',
    NO_GLOBAL_TASK_POP_UP: 'Цілей поки що немає',
    NO_ANY_TASKS: 'Завдань немає',
    SHOW_CALENDAR: 'Показати календар',
    COMING_SOON: 'Незабаром',
    NO_REG_TASKS: 'Завдань за таким розкладом немає',
    DONE_GLOBAL_TASK: 'Зроблено',
    DISCONNECT_TASK_TITLE_POP_UP: "Від'єднати завдання від цілі",
    ADD_DATE: 'Встановити дату',
    DISCONNECT_TASK_TEXT_POP_UP: 'Завдання буде переміщене до загального списку та не буде впливати на прогрес цілі',
    CHECK_EMAIL_TITLE: 'Перевірте свою електронну пошту',
    CHECK_EMAIL_DESCRIPTION: 'Ми надіслали вам електронний лист із підтвердженням. Натисніть на посилання та перейдіть за ним.',
    LOGIN_TITLE: 'Увійдіть у свій акаунт',
    ALREADY_REG: 'Уже зареєстровані',
    SIGN_IN: 'Вхід',
    SIGN_UP: 'Реєстрація',
    WITH_SOCIAL_NETWORK: 'за допомогою соцмереж',
    CREATE_ACCOUNT: 'Створіть акаунт',
    NOT_A_MEMBER: 'Немає акаунта',
    PASSWORD_FORGET: 'Забули пароль',
    PASSWORD_FORGET_TITLE: 'Відновити пароль',
    PASSWORD_FORGET_DESCRIPTION: 'Введіть адресу електронної пошти ми надішлемо вам посилання для відновлення пароля',
    RESET: 'Відправити посилання',
    EMAIL: 'Електронна пошта',
    PASSWORD_OLD: 'Поточний пароль',
    PASSWORD: 'Пароль',
    PASSWORD_CONFIRM: 'Підтвердіть пароль',
    RESET_MY_PASSWORD: 'Змінити пароль',
    NAME: "І'мя (латиницею)",
    PASSWORD_RESET_INFO: 'Вам було вислано посилання для відновлення пароля.',
    SAVE_CHANGES_TITLE: 'Зберегти зміни',
    SAVE_CHANGES_DESCRIPT: 'Незбережені змінини будуть втрачені. Зберегти зміни перед виходом',
    DO_NOT_SAVE: 'Не зберігати',
    TODAY_TASKS: 'Завдання на сьогодні',
    HELP: 'Підтримка',
    HELP_TEXT: "Щоб отримати допомогу або зв'язатися з командою Purport, напишіть нам за адресою",
    TERMS_INFO_SIGN_UP: 'Використовуючи Purport, ви приймаєте наші {{TermsAndConditionsLink}} і {{PrivacyPolicyLink}}',
    MOVE_TO_DELAYED_TITLE: 'Відкласти завдання на потім',
    MOVE_TO_DELAYED_DESCRIPT: 'Параметри (дата, час, пріоритет) будуть втрачені, завдання буде перенесене до відкладених завдань без дати',
    LABEL_CREATED: 'Ярлик створено',
    LABEL_UPDATED: 'Ярлик оновлено',
    LABEL_DELETED: 'Ярлик видалено',
    LABEL_TITLE: 'Ярлики',
    TOOLTIP_ADD_LABEL: 'Додати ярлик',
    ADD_LABEL: 'Новий ярлик',
    NO_LABELS_POP_UP: 'Ярликів поки що немає',
    NOTES: 'Додати нотатку',
    DELETE_LABEL: 'Видалити ярлик',
    SELECT_COLOR_LABEL: 'Колір ярлика',
    INTERVAL: 'Інтервал',
    FILTER: 'Фільтр',
    SORT_TITLE: 'Сортувати',
    SORT_NAME: 'По алфавіту (а-я)',
    SORT_PRIORITY: 'Високий ➔ низький пріоритет',
    SORT_STATUS: 'Заплановані ➔ виконані',
    SORT_DEFAULT: 'За замовчуванням',
    SORT_TIME: 'По часу',
  },
  EN: {
    NIGHT_MODE: 'Night mode',
    ADVICE_SETTINGS: 'Do not show tips',
    TASKS: 'Tasks',
    CALENDAR: 'Calendar',
    TASK_LIST: 'Tasks list',
    DELAYED: 'Delayed',
    ACCOUNT: 'Account',
    CREATE_GLOBAL_TASK: 'Create goal',
    TASK: 'Create task',
    NEW_TASK: 'Add a task',
    NEW_GOAL: 'Add a goal',
    RESCHEDULE_ON_DATE: 'Reschedule on date',
    RESCHEDULE: 'Reschedule',
    NO_TASK: 'No task',
    NO_TASKS: 'No tasks',
    CONNECT_TO_GOAL: 'Add task to your goal',
    DISCONNECT_TASK: 'Disconnect the task',
    NEW_DELAYED_TASK: 'New task without date',
    IMPORTANT_TASK: 'Important task',
    PRIORITY: 'Priority',
    HIGH_PRIORITY: 'High',
    COMMON_PRIORITY: 'Common',
    STATUS: 'Status',
    TYPE: 'Type',
    REGULAR_TASK: 'Regular',
    GLOBAL_TASK: 'Global',
    DELAYED_TASKS: 'Tasks without date',
    SINGLE_TASK: 'One-time',
    DATE_SINGLE_TASK: 'Date',
    DATE_AND_TIME_TASK: 'Date and time',
    TIME_NEED: 'Hours needed',
    TIME: 'Hours',
    CONFIRM: 'Yes',
    TIME_NEED_IN_TASK: 'Time needed',
    ADD_BUTTON: 'Add',
    SAVE_BUTTON: 'Save',
    DELETE_BUTTON: 'Delete',
    CANCEL_BUTTON: 'Cancel',
    DELETE_TASK: 'Delete task',
    RENAME_REGULAR_TASKS: 'Rename all tasks',
    DAY: 'Day',
    HOUR: 'h',
    MINUTE: 'min',
    WEEK: 'Week',
    WEEK_SHORT: 'wk',
    MONTH_SHORT: 'mo',
    MONTH: 'Month',
    YEAR: 'Year',
    LIST: 'List',
    NEW_TASK_BUTTON: 'New task',
    REPEATING_TASK: 'Schedule',
    START_FINISH_TASK: 'Task start and end date',
    START_DATE: 'Start date',
    FINISH_DATE: 'Finish date',
    UA: 'Ukrainian',
    EN: 'English',
    RU: 'Russian',
    DISABLE_TASKS_DONE: 'Disable tasks done',
    GENERAL_INFO_TITLE: 'General',
    SETTINGS_TITLE: 'Setting',
    LANGUAGE_SELECT: 'Language',
    DISABLE_HELP: 'Hide hints',
    DISABLE_NEWS: 'Newsletter (news from the Purport)',
    DELETE_ACCOUNT: 'Delete account',
    EDIT_PASSWORD: 'Change password',
    STATISTICS: 'Statistics',
    TASKS_NUMBER: 'Tasks number',
    TASK_PLANNED: 'Planned',
    TASKS_DONE: 'Done',
    TASK_ALL: 'All tasks',
    TASKS_GOAL: 'Goals',
    TASK_DELAYED: 'Overdue',
    STATISTICS_CURRENT_WEEK: 'Statistics for current the week',
    STATISTICS_LAST_WEEK: 'Last weeks productivity',
    INDEX: 'Tasks met (%)',
    GLOBAL_TASK_TITLE: 'Global goals',
    ALL_SIMPLE_TASK_TITLE: 'All tasks',
    ACHIEVE_GOAL: 'Achieve the goal in ',
    GOAL_TERM: 'Period of achieving the goal',
    SELECT_GLOBAL_TASK: 'Select goal:',
    SELECT_LABEL: 'Select label',
    GO_BACK: 'Back',
    DAYS_TO_END: 'days',
    GOAL_OVERDUE_TITLE: 'The goal is overdue for',
    DONE: 'Done!',
    TASK_TRANSFERRED_TO_DELAYED: 'Task transferred to Delayed',
    TASK_CREATED: 'Task created',
    GOAL_CREATED: 'Goal created',
    GOAL_DELETED: 'Goal deleted',
    TASK_DELETED: 'Task deleted',
    GOAL_UPDATED: 'Goal updated',
    TASK_UPDATED: 'Task updated',
    LOG_OUT: 'Log Out',
    GOAL_MET: 'Goals met',
    USED: 'of {{taskNumberLimit}} used',
    TASK_TITLE: 'Task title',
    DATE_PERIOD: 'Date / period',
    HOURS: 'Hours',
    TIME_TO_FINISH: 'Time to finish',
    ALL_GOALS: 'All goals',
    CREATE_YOUR_DAY: 'Create your day',
    DONE_NUMBER_OF: 'Done {{tasksDoneNumber}} of {{tasksNumber}} tasks',
    END_DATE_FOR_ACHIEVING_THE_GOAL: 'End date for achieving the goal',
    CHANGE_END_DATE: 'Change end date',
    GOAL_WAS_CREATED: 'Goal was created',
    RELATED_TASKS: 'Related tasks',
    RELATED_TASKS_ON_CALENDAR: 'Tasks on calendar',
    GOAL_OVERDUE_FOR: 'The goal is overdue for {{daysNumber}} days',
    GOAL_TODAY: 'Complete the goal today',
    LEFT_TO_COMPLETE: '{{daysNumberLeft}} days left to finish',
    TASKS_DONE_ALL: 'Done / planned',
    ALL_TASK_DONE_TEXT: 'All tasks are done',
    VISIT_EMAIL: 'Please, visit email',
    NO_DELAYED_TASKS: 'Oops... It is empty in here',
    CREATE_FIRST_DELAYED_TASK: 'Add the first task',
    CREATE_WEEK_TITLE: 'Plan a productive week',
    CREATE_MONTH_TITLE: 'There are no tasks for this month yet',
    NO_ANY_TASKS: 'There are no tasks',
    NO_GLOBAL_TASK_POP_UP: 'No goals yet',
    SHOW_CALENDAR: 'Show calendar',
    COMING_SOON: 'Coming soon',
    NO_REG_TASKS: 'There are no tasks according to the schedule',
    DONE_GLOBAL_TASK: 'Done',
    DISCONNECT_TASK_TITLE_POP_UP: 'Detach task from goal',
    ADD_DATE: 'Set date',
    DISCONNECT_TASK_TEXT_POP_UP: 'The task will be moved to the general list and will not affect the progress of the goal',
    CHECK_EMAIL_TITLE: 'Check your email',
    CHECK_EMAIL_DESCRIPTION: 'We have sent you a verification email. Click and follow the link inside it.',
    LOGIN_TITLE: 'Login to your account',
    ALREADY_REG: 'Already registered',
    SIGN_IN: 'Sign In',
    SIGN_UP: 'Sign Up',
    WITH_SOCIAL_NETWORK: 'with your social network',
    CREATE_ACCOUNT: 'Create your account',
    NOT_A_MEMBER: 'Not a member',
    PASSWORD_FORGET: 'Forgot password',
    PASSWORD_FORGET_TITLE: 'Reset password',
    PASSWORD_FORGET_DESCRIPTION: "Enter your email address and we'll send you a link to reset your password",
    RESET: 'Send me the link',
    EMAIL: 'E-mail',
    PASSWORD_OLD: 'Current password',
    PASSWORD: 'Password',
    PASSWORD_CONFIRM: 'Confirm password',
    RESET_MY_PASSWORD: 'Reset Password',
    NAME: 'Full name',
    PASSWORD_RESET_INFO: 'You’ve been emailed a password reset link',
    SAVE_CHANGES_TITLE: 'Save changes',
    SAVE_CHANGES_DESCRIPT: 'Your unsaved changes will be lost. Save changes before closing',
    DO_NOT_SAVE: "Don't save",
    TODAY_TASKS: 'Tasks for today',
    HELP: 'Support',
    HELP_TEXT: 'For help and to get in touch with the Purport team, email us at',
    TERMS_INFO_SIGN_UP: 'By using Purport you accept our {{TermsAndConditionsLink}} and {{PrivacyPolicyLink}}',
    MOVE_TO_DELAYED_TITLE: 'Move tasks to delayed',
    MOVE_TO_DELAYED_DESCRIPT: 'Parameters (date, time, priority) will be lost, the task will be moved to delayed',
    LABEL_CREATED: 'Label created',
    LABEL_UPDATED: 'Label updated',
    LABEL_DELETED: 'Label deleted',
    LABEL_TITLE: 'Labels',
    TOOLTIP_ADD_LABEL: 'Add label',
    ADD_LABEL: 'New label',
    NO_LABELS_POP_UP: 'No labels yet',
    NOTES: 'Add notes',
    DELETE_LABEL: 'Delete label',
    SELECT_COLOR_LABEL: 'Label color',
    INTERVAL: 'Interval',
    FILTER: 'Filter',
    SORT_TITLE: 'Select sort order',
    SORT_NAME: 'Alphabetical (a-z)',
    SORT_PRIORITY: 'High ➔ low priority',
    SORT_STATUS: 'Not done ➔ done',
    SORT_DEFAULT: 'Default',
    SORT_TIME: 'Time',
  },
  RU: {
    ADVICE_SETTINGS: 'Не показывать советы',
    TASKS: 'Задания',
    CALENDAR: 'Календарь',
    TASK_LIST: 'Список заданий',
    DELAYED: 'Отложенные',
    ACCOUNT: 'Аккаунт',
    CREATE_GLOBAL_TASK: 'Создать цель',
    TASK: 'Создать задание',
    NEW_TASK: 'Добавьте название задания',
    NEW_GOAL: 'Добавьте название цели',
    RESCHEDULE_ON_DATE: 'Перенести на дату',
    RESCHEDULE: 'Перенести',
    NO_TASK: 'Задания нет',
    NO_TASKS: 'Заданий нет',
    CONNECT_TO_GOAL: 'Добавьте задание к цели',
    DISCONNECT_TASK: 'Отсоединить задание',
    NEW_DELAYED_TASK: 'Новое задание без термина',
    IMPORTANT_TASK: 'Високий приоритет',
    REGULAR_TASK: 'Регулярная',
    GLOBAL_TASK: 'Глобальная',
    DELAYED_TASKS: 'Задание без термина',
    SINGLE_TASK: 'Разовая',
    CONFIRM: 'Да',
    DATE_SINGLE_TASK: 'Дата',
    DATE_AND_TIME_TASK: 'Дата и время',
    TIME_NEED: 'Часы',
    TIME: 'Часы',
    TIME_NEED_IN_TASK: 'Необходимо времени',
    ADD_BUTTON: 'Добавить',
    SAVE_BUTTON: 'Сохранить',
    DELETE_BUTTON: 'Удалить',
    CANCEL_BUTTON: 'Отменить',
    DELETE_TASK: 'Удалить задание',
    DAY: 'День',
    HOUR: 'ч.',
    WEEK: 'Неделя',
    MONTH: 'Месяц',
    YEAR: 'Год',
    LIST: 'Список',
    NEW_TASK_BUTTON: 'Новое задание',
    REPEATING_TASK: 'Расписание повторов',
    START_FINISH_TASK: 'Дата начала и завершения задания',
    START_DATE: 'Начало',
    FINISH_DATE: 'Конец',
    UA: 'Украинский',
    EN: 'Английский',
    RU: 'Русский',
    DISABLE_TASKS_DONE: 'Скрыть завершенные задания',
    GENERAL_INFO_TITLE: 'Основное',
    SETTINGS_TITLE: 'Настройки',
    LANGUAGE_SELECT: 'Язык',
    DISABLE_HELP: 'Скрыть подсказки',
    DISABLE_NEWS: 'Новостная рассылка',
    DELETE_ACCOUNT: 'Удалить аккаунт',
    EDIT_PASSWORD: 'Изменить пароль',
    STATISTICS: 'Статистика',
    TASKS_NUMBER: 'Количество заданий',
    TASK_PLANNED: 'Запланировано',
    TASKS_DONE: 'Выполнено',
    TASK_ALL: 'Все задания',
    TASKS_GOAL: 'Цели',
    TASK_DELAYED: 'Просрочено',
    STATISTICS_LAST_WEEK: 'Статистика за неделю',
    INDEX: 'Выполненные задания (%)',
    GLOBAL_TASK_TITLE: 'Глобальные цели',
    ALL_SIMPLE_TASK_TITLE: 'Все задания',
    ACHIEVE_GOAL: 'Достижения цели через',
    SELECT_GLOBAL_TASK: 'Выбрать цель:',
    GO_BACK: 'Назад',
    DAYS_TO_END: 'дней',
    GOAL_OVERDUE_TITLE: 'Цель просроченная на',
    DONE: 'Цель достигнута',
    TASK_CREATED: 'Задание создано',
    GOAL_CREATED: 'Цель создана',
    GOAL_DELETED: 'Цель удалена',
    TASK_DELETED: 'Задание удалено',
    GOAL_UPDATED: 'Цель обновлена',
    TASK_UPDATED: 'Задание обновлено',
    LOG_OUT: 'Выйти',
    GOAL_MET: 'Достигнутые цели',
    USED: 'с {{taskNumberLimit}} использовано',
    TASK_TITLE: 'Название задания',
    DATE_PERIOD: 'Дата / период',
    HOURS: 'Часы',
    TIME_TO_FINISH: 'Время на выполнение',
    ALL_GOALS: 'Все цели',
    CREATE_YOUR_DAY: 'Создай свой день',
    DONE_NUMBER_OF: 'Выполнено {{tasksDoneNumber}} из {{tasksNumber}} заданий',
    END_DATE_FOR_ACHIEVING_THE_GOAL: 'Конечная дата достижения цели',
    CHANGE_END_DATE: 'Изменить конечную дату',
    GOAL_WAS_CREATED: 'Цель была создана',
    RELATED_TASKS: 'Связанные задания',
    RELATED_TASKS_ON_CALENDAR: 'Календарь заданий',
    GOAL_OVERDUE_FOR: 'Цель просрочена на {{daysNumber}} дней',
    GOAL_TODAY: 'Завершение цели сегодня',
    LEFT_TO_COMPLETE: 'До завершения осталось {{daysNumberLeft}} дней из {{daysNumber}}',
    TASKS_DONE_ALL: 'Сделано / все',
    ALL_TASK_DONE_TEXT: 'Все задания сделаны',
    VISIT_EMAIL: 'Пожалуйста, проверьте почту',
    NO_DELAYED_TASKS: 'Здесь пока пусто',
    CREATE_FIRST_DELAYED_TASK: 'Добавь задание',
    CREATE_WEEK_TITLE: 'Спланируй свою неделю',
    CREATE_MONTH_TITLE: 'Заданий на этот месяц пока нет',
    NO_ANY_TASKS: 'Заданий пока нет',
    NO_GLOBAL_TASK_POP_UP: 'Целей пока нет',
    SHOW_CALENDAR: 'Показать календарь',
    COMING_SOON: 'Скоро будет',
    NO_REG_TASKS: 'Заданий по такому расписанию нет',
    DONE_GLOBAL_TASK: 'Сделано',
    DISCONNECT_TASK_TITLE_POP_UP: 'Отсоединить задание от цели',
    ADD_DATE: 'Установить дату',
    DISCONNECT_TASK_TEXT_POP_UP: 'Задание будет перемещено в общий список и не будет влиять на прогресс цели',
    CHECK_EMAIL_TITLE: 'Проверьте свою электронную почту',
    CHECK_EMAIL_DESCRIPTION: 'Мы отправили вам письмо с подтверждением. Щелкните и перейдите по ссылке внутри него.',
    LOGIN_TITLE: 'Войдите в свой аккаунт',
    ALREADY_REG: 'Уже зарегистрированы',
    SIGN_IN: 'Войти',
    SIGN_UP: 'Регистрация',
    WITH_SOCIAL_NETWORK: 'через соцсети',
    CREATE_ACCOUNT: 'Создайте аккаунт',
    NOT_A_MEMBER: 'Ещё нет аккаунта',
    PASSWORD_FORGET: 'Забыли пароль',
    PASSWORD_FORGET_TITLE: 'Сбросить пароль',
    PASSWORD_FORGET_DESCRIPTION: 'Введите адрес электронной почты мы отправим вам ссылку для сброса пароля',
    RESET: 'Отправить ссылку',
    EMAIL: 'Электронная почта',
    PASSWORD_OLD: 'Текущий пароль',
    PASSWORD: 'Пароль',
    PASSWORD_CONFIRM: 'Подтвердите пароль',
    RESET_MY_PASSWORD: 'Изменить пароль',
    NAME: 'Имя (латиницей)',
    PASSWORD_RESET_INFO: 'Вам была отправлена ссылка для восстановления пароля.',
    SAVE_CHANGES_TITLE: 'Сохранить изменения',
    SAVE_CHANGES_DESCRIPT: 'Несохраненные изменения будут утрачены. Сохранить изменения перед выходом',
    DO_NOT_SAVE: 'Не сохранять',
    TODAY_TASKS: 'Задания на сегодня',
    HELP: 'Служба поддержки',
    HELP_TEXT: 'Чтобы получить помощь или связаться с командой Purport, напишите нам по адресу',
    TERMS_INFO_SIGN_UP: 'Используя Purport вы принимаете наши {{TermsAndConditionsLink}} и {{PrivacyPolicyLink}}',
  },
  DE: {
    NIGHT_MODE: 'Nachtmodus',
    ADVICE_SETTINGS: 'Keine Tipps anzeigen',
    TASKS: 'Aufgaben',
    CALENDAR: 'Kalender',
    TASK_LIST: 'Aufgabenliste',
    DELAYED: 'Verspätet',
    ACCOUNT: 'Konto',
    CREATE_GLOBAL_TASK: 'Ziel erstellen',
    TASK: 'Aufgabe erstellen',
    NEW_TASK: 'Aufgabe hinzufügen',
    NEW_GOAL: 'Ziel hinzufügen',
    RESCHEDULE_ON_DATE: 'Auf Datum verschieben',
    RESCHEDULE: 'Verschieben',
    NO_TASK: 'Keine Aufgabe',
    NO_TASKS: 'Keine Aufgaben',
    CONNECT_TO_GOAL: 'Aufgabe zum Ziel hinzufügen',
    DISCONNECT_TASK: 'Aufgabe trennen',
    NEW_DELAYED_TASK: 'Neue Aufgabe ohne Datum',
    IMPORTANT_TASK: 'Wichtige Aufgabe',
    PRIORITY: 'Priorität',
    HIGH_PRIORITY: 'Hoch',
    COMMON_PRIORITY: 'Normal',
    STATUS: 'Status',
    TYPE: 'Typ',
    REGULAR_TASK: 'Regulär',
    GLOBAL_TASK: 'Global',
    DELAYED_TASKS: 'Aufgaben ohne Datum',
    SINGLE_TASK: 'Einmalig',
    DATE_SINGLE_TASK: 'Datum',
    DATE_AND_TIME_TASK: 'Datum und Uhrzeit',
    TIME_NEED: 'Benötigte Stunden',
    TIME: 'Stunden',
    CONFIRM: 'Ja',
    TIME_NEED_IN_TASK: 'Benötigte Zeit',
    ADD_BUTTON: 'Hinzufügen',
    SAVE_BUTTON: 'Speichern',
    DELETE_BUTTON: 'Löschen',
    CANCEL_BUTTON: 'Abbrechen',
    DELETE_TASK: 'Aufgabe löschen',
    RENAME_REGULAR_TASKS: 'Alle Aufgaben umbenennen',
    DAY: 'Tag',
    HOUR: 'h.',
    MINUTE: 'min.',
    WEEK: 'Woche',
    WEEK_SHORT: 'w.',
    MONTH_SHORT: 'mo.',
    MONTH: 'Monat',
    YEAR: 'Jahr',
    LIST: 'Liste',
    NEW_TASK_BUTTON: 'Neue Aufgabe',
    REPEATING_TASK: 'Wiederholen',
    START_FINISH_TASK: 'Aufgaben Start- und -enddatum',
    START_DATE: 'Startdatum',
    FINISH_DATE: 'Enddatum',
    UA: 'Ukrainisch',
    EN: 'Englisch',
    RU: 'Russisch',
    DISABLE_TASKS_DONE: 'Erledigte Aufgaben deaktivieren',
    GENERAL_INFO_TITLE: 'Allgemein',
    SETTINGS_TITLE: 'Einstellungen',
    LANGUAGE_SELECT: 'Sprache',
    DISABLE_HELP: 'Hinweise ausblenden',
    DISABLE_NEWS: 'Newsletter (Nachrichten von Purport)',
    DELETE_ACCOUNT: 'Konto löschen',
    EDIT_PASSWORD: 'Passwort ändern',
    STATISTICS: 'Statistiken',
    TASKS_NUMBER: 'Anzahl Aufgaben',
    TASK_PLANNED: 'Geplant',
    TASKS_DONE: 'Erledigt',
    TASK_ALL: 'Alle Aufgaben',
    TASKS_GOAL: 'Ziele',
    TASK_DELAYED: 'Überfällig',
    STATISTICS_CURRENT_WEEK: 'Statistiken für die aktuelle Woche',
    STATISTICS_LAST_WEEK: 'Produktivität der letzten Woche',
    INDEX: 'Erledigte Aufgaben (%)',
    GLOBAL_TASK_TITLE: 'Globale Ziele',
    ALL_SIMPLE_TASK_TITLE: 'Alle Aufgaben',
    ACHIEVE_GOAL: 'Ziel erreichen in ',
    GOAL_TERM: 'Zeitraum für die Zielerreichung',
    SELECT_GLOBAL_TASK: 'Ziel auswählen:',
    SELECT_LABEL: 'Label auswählen',
    GO_BACK: 'Zurück',
    DAYS_TO_END: 'Tage',
    GOAL_OVERDUE_TITLE: 'Ziel ist seit {{daysNumber}} Tagen überfällig',
    DONE: 'Erledigt!',
    TASK_TRANSFERRED_TO_DELAYED: 'Aufgabe zu "Überfällig" verschoben',
    TASK_CREATED: 'Aufgabe erstellt',
    GOAL_CREATED: 'Ziel erstellt',
    GOAL_DELETED: 'Ziel gelöscht',
    TASK_DELETED: 'Aufgabe gelöscht',
    GOAL_UPDATED: 'Ziel aktualisiert',
    TASK_UPDATED: 'Aufgabe aktualisiert',
    LOG_OUT: 'Abmelden',
    GOAL_MET: 'Erreichte Ziele',
    USED: 'von {{taskNumberLimit}} benutzt',
    TASK_TITLE: 'Aufgabenname',
    DATE_PERIOD: 'Datum / Zeitraum',
    HOURS: 'Stunden',
    TIME_TO_FINISH: 'Restzeit',
    ALL_GOALS: 'Alle Ziele',
    CREATE_YOUR_DAY: 'Gestalte deinen Tag',
    DONE_NUMBER_OF: '{{tasksDoneNumber}} von {{tasksNumber}} Aufgaben erledigt',
    END_DATE_FOR_ACHIEVING_THE_GOAL: 'Enddatum für die Zielerreichung',
    CHANGE_END_DATE: 'Enddatum ändern',
    GOAL_WAS_CREATED: 'Ziel wurde erstellt',
    RELATED_TASKS: 'Verbundene Aufgaben',
    RELATED_TASKS_ON_CALENDAR: 'Aufgaben im Kalender',
    GOAL_OVERDUE_FOR: 'Ziel ist seit {{daysNumber}} Tagen überfällig',
    GOAL_TODAY: 'Ziel heute abschließen',
    LEFT_TO_COMPLETE: '{{daysNumberLeft}} Tage bis zur Fertigstellung',
    TASKS_DONE_ALL: 'Erledigt / geplant',
    ALL_TASK_DONE_TEXT: 'Alle Aufgaben sind erledigt',
    VISIT_EMAIL: 'Bitte E-Mail besuchen',
    NO_DELAYED_TASKS: 'Ups... Hier ist es leer',
    CREATE_FIRST_DELAYED_TASK: 'Erste Aufgabe hinzufügen',
    CREATE_WEEK_TITLE: 'Plane eine produktive Woche',
    CREATE_MONTH_TITLE: 'Es gibt noch keine Aufgaben für diesen Monat',
    NO_ANY_TASKS: 'Es gibt keine Aufgaben',
    NO_GLOBAL_TASK_POP_UP: 'Noch keine Ziele',
    SHOW_CALENDAR: 'Kalender anzeigen',
    COMING_SOON: 'Kommt bald',
    NO_REG_TASKS: 'Es gibt keine Aufgaben gemäß dem Zeitplan',
    DONE_GLOBAL_TASK: 'Erledigt',
    DISCONNECT_TASK_TITLE_POP_UP: 'Aufgabe vom Ziel lösen',
    ADD_DATE: 'Datum festlegen',
    DISCONNECT_TASK_TEXT_POP_UP: 'Die Aufgabe wird in die allgemeine Liste verschoben und beeinträchtigt nicht den Fortschritt des Ziels',
    CHECK_EMAIL_TITLE: 'Überprüfe deine E-Mails',
    CHECK_EMAIL_DESCRIPTION: 'Wir haben dir eine Verifizierungs-E-Mail geschickt. Klicke darauf und folge dem darin enthaltenen Link.',
    LOGIN_TITLE: 'Anmelden bei deinem Konto',
    ALREADY_REG: 'Bereits registriert',
    SIGN_IN: 'Anmelden',
    SIGN_UP: 'Registrieren',
    WITH_SOCIAL_NETWORK: 'mit deinem sozialen Netzwerk',
    CREATE_ACCOUNT: 'Dein Konto erstellen',
    NOT_A_MEMBER: 'Kein Mitglied',
    PASSWORD_FORGET: 'Passwort vergessen',
    PASSWORD_FORGET_TITLE: 'Passwort zurücksetzen',
    PASSWORD_FORGET_DESCRIPTION: 'Gib deine E-Mail-Adresse ein, und wir senden dir einen Link zum Zurücksetzen deines Passworts',
    RESET: 'Sende mir den Link',
    EMAIL: 'E-Mail',
    PASSWORD_OLD: 'Aktuelles Passwort',
    PASSWORD: 'Passwort',
    PASSWORD_CONFIRM: 'Passwort bestätigen',
    RESET_MY_PASSWORD: 'Passwort zurücksetzen',
    NAME: 'Vollständiger Name',
    PASSWORD_RESET_INFO: 'Dir wurde ein Link zum Zurücksetzen deines Passworts per E-Mail zugesandt',
    SAVE_CHANGES_TITLE: 'Änderungen speichern',
    SAVE_CHANGES_DESCRIPT: 'Deine ungespeicherten Änderungen gehen verloren. Änderungen vor dem Schließen speichern',
    DO_NOT_SAVE: 'Nicht speichern',
    TODAY_TASKS: 'Aufgaben für heute',
    HELP: 'Unterstützung',
    HELP_TEXT: 'Für Hilfe und um Kontakt mit dem Purport-Team aufzunehmen, sende uns eine E-Mail an',
    TERMS_INFO_SIGN_UP: 'Durch die Nutzung von Purport akzeptierst du unsere {{TermsAndConditionsLink}} und {{PrivacyPolicyLink}}',
    MOVE_TO_DELAYED_TITLE: 'Aufgaben in den Verzug verschieben',
    MOVE_TO_DELAYED_DESCRIPT: 'Parameter (Datum, Uhrzeit, Priorität) gehen verloren, die Aufgabe wird in den Verzug verschoben',
    LABEL_CREATED: 'Label erstellt',
    LABEL_UPDATED: 'Label aktualisiert',
    LABEL_DELETED: 'Label gelöscht',
    LABEL_TITLE: 'Labels',
    TOOLTIP_ADD_LABEL: 'Label hinzufügen',
    ADD_LABEL: 'Neues Label',
    NO_LABELS_POP_UP: 'Noch keine Labels',
    NOTES: 'Notizen hinzufügen',
    DELETE_LABEL: 'Label löschen',
    SELECT_COLOR_LABEL: 'Label-Farbe',
    INTERVAL: 'Intervall',
    FILTER: 'Filter',
    SORT_TITLE: 'Sortierreihenfolge auswählen',
    SORT_NAME: 'Alphabetisch (a-z)',
    SORT_PRIORITY: 'Hohe ➔ niedrige Priorität',
    SORT_STATUS: 'Nicht erledigt ➔ erledigt',
    SORT_DEFAULT: 'Standard',
    SORT_TIME: 'Zeit',
  },
};

export const ERRORS = {
  UA: {
    TASKS_NUMBER_LIMIT: 'Перевищено ліміт кількості завдань',
    PASSWORD_SYMBOL_NUMBER_ERROR: 'Більше 12 та менше 64 символів',
    PASSWORD_LOWER_LETTERS_ERROR: 'Латинські літери [a-z]',
    PASSWORD_UPPER_LETTERS_ERROR: 'Латинські літери [A-Z]',
    PASSWORD_NUMBERS_ERROR: 'Цифри [0-9]',
    PASSWORD_SPECIALS_ERROR: 'Спеціальні символи [!@#%_=]',
    PASSWORD_RESTRICTED_SPECIALS_ERROR: 'Відсутні спеціальні символи окрім [!@#%_=]',
    PASSWORD_TWO_ERROR: 'Паролі не співпадають',
    MAX_TITLE_LENGTH_ERROR: `Назва завдання не може перевищувати ${MAX_TITLE_LENGTH} символів`,
    MAX_LABEL_LENGTH_ERROR: `Назва ярлика не може перевищувати ${MAX_LABEL_LENGTH} символів`,
    MAX_USERNAME_LENGTH_ERROR: `Ім'я не може перевищувати ${MAX_LABEL_LENGTH} символів`,
    MAX_NOTE_LENGTH_ERROR: `Довжина нотатки не може перевищувати ${MAX_NOTES_LENGTH} символів`,
    'auth/email-already-in-use': 'Неправильні дані користувача',
    'auth/account-exists-with-different-credential': 'Неправильні дані користувача',
    'auth/user-not-found': 'Неправильний email або пароль',
    'auth/wrong-password': 'Неправильний або відсутній пароль',
  },
  EN: {
    TASKS_NUMBER_LIMIT: 'Tasks number limit hit',
    PASSWORD_SYMBOL_NUMBER_ERROR: 'More than 12 and less than 64 symbols',
    PASSWORD_LOWER_LETTERS_ERROR: 'Letters [a-z]',
    PASSWORD_UPPER_LETTERS_ERROR: 'Letters [A-Z]',
    PASSWORD_NUMBERS_ERROR: 'Numbers [0-9]',
    PASSWORD_SPECIALS_ERROR: 'Special symbols [!@#%_=]',
    PASSWORD_RESTRICTED_SPECIALS_ERROR: 'No special symbols except [!@#%_=]',
    PASSWORD_TWO_ERROR: 'Passwords do not match',
    MAX_TITLE_LENGTH_ERROR: `Title length shouldn't be longer than ${MAX_TITLE_LENGTH} characters`,
    MAX_LABEL_LENGTH_ERROR: `Label length shouldn't be longer than ${MAX_LABEL_LENGTH} characters`,
    MAX_USERNAME_LENGTH_ERROR: `User name length shouldn't be longer than ${MAX_LABEL_LENGTH} characters`,
    MAX_NOTE_LENGTH_ERROR: `Note length shouldn't be longer than ${MAX_NOTES_LENGTH} characters`,
    'auth/email-already-in-use': 'An account data is wrong',
    'auth/account-exists-with-different-credential': 'An account data is wrong',
    'auth/user-not-found': 'Wrong email or password',
    'auth/wrong-password': 'Wrong or absent password',
  },
  RU: {
    TASKS_NUMBER_LIMIT: 'Превышено лимит количества заданий',
    PASSWORD_SYMBOL_NUMBER_ERROR: 'Больше 12 и меньше 64 символов',
    PASSWORD_LOWER_LETTERS_ERROR: 'Латинские буквы [a-z]',
    PASSWORD_UPPER_LETTERS_ERROR: 'Латинские буквы [A-Z]',
    PASSWORD_NUMBERS_ERROR: 'Цифры [0-9]',
    PASSWORD_SPECIALS_ERROR: 'Специальные символы [!@#%_=]',
    PASSWORD_RESTRICTED_SPECIALS_ERROR: 'Отсутствуют специальные символы кроме [!@#%_=]',
    PASSWORD_TWO_ERROR: 'Пароли не совпадают',
    MAX_TITLE_LENGTH_ERROR: `Название задания не может превышать ${MAX_TITLE_LENGTH} символов`,
    'auth/email-already-in-use': 'Неверные данные пользователя',
    'auth/account-exists-with-different-credential': 'Неверные данные пользователя',
    'auth/user-not-found': 'Неверный email или пароль',
    'auth/wrong-password': 'Неверный или отсутствующий пароль',
  },
  DE: {
    TASKS_NUMBER_LIMIT: 'Maximale Anzahl von Aufgaben erreicht',
    PASSWORD_SYMBOL_NUMBER_ERROR: 'Mehr als 12 und weniger als 64 Symbole',
    PASSWORD_LOWER_LETTERS_ERROR: 'Buchstaben [a-z]',
    PASSWORD_UPPER_LETTERS_ERROR: 'Buchstaben [A-Z]',
    PASSWORD_NUMBERS_ERROR: 'Zahlen [0-9]',
    PASSWORD_SPECIALS_ERROR: 'Sonderzeichen [!@#%=]',
    PASSWORD_RESTRICTED_SPECIALS_ERROR: 'Keine Sonderzeichen außer [!@#%=]',
    PASSWORD_TWO_ERROR: 'Passwörter stimmen nicht überein',
    MAX_TITLE_LENGTH_ERROR: `Die Titellänge sollte nicht länger als ${MAX_TITLE_LENGTH} Zeichen sein`,
    MAX_LABEL_LENGTH_ERROR: `Die Label-Länge sollte nicht länger als ${MAX_LABEL_LENGTH} Zeichen sein`,
    MAX_USERNAME_LENGTH_ERROR: `Die Benutzernamenlänge sollte nicht länger als ${MAX_LABEL_LENGTH} Zeichen sein`,
    MAX_NOTE_LENGTH_ERROR: `Die Notiz-Länge sollte nicht länger als ${MAX_NOTES_LENGTH} Zeichen sein`,
    'auth/email-already-in-use': 'Falsche Kontodaten',
    'auth/account-exists-with-different-credential': 'Falsche Kontodaten',
    'auth/user-not-found': 'Falsche E-Mail oder Passwort',
    'auth/wrong-password': 'Falsches oder fehlendes Passwort',
  },
};

export const WEEK = {
  UA: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  EN: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  RU: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  DE: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
};

export const MONTHS = {
  UA: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
  EN: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  RU: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  DE: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
};

export const MONTH_TO_ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

export const DAYS_OF_WEEK = {
  UA: [
    {
      id: 'Понеділок',
      value: '1',
      name: 'Пн',
    },
    {
      id: 'Вівторок',
      value: '2',
      name: 'Вт',
    },
    {
      id: 'Середа',
      value: '3',
      name: 'Ср',
    },
    {
      id: 'Четвер',
      value: '4',
      name: 'Чт',
    },
    {
      id: "П'ятниця",
      value: '5',
      name: 'Пт',
    },
    {
      id: 'Субота',
      value: '6',
      name: 'Сб',
    },
    {
      id: 'Неділя',
      value: '0',
      name: 'Нд',
    },
  ],
  EN: [
    {
      id: 'monday',
      value: '1',
      name: 'Mon',
    },
    {
      id: 'tuesday',
      value: '2',
      name: 'Tue',
    },
    {
      id: 'wednesday',
      value: '3',
      name: 'Wed',
    },
    {
      id: 'thursday',
      value: '4',
      name: 'Thur',
    },
    {
      id: 'friday',
      value: '5',
      name: 'Fr',
    },
    {
      id: 'saturday',
      value: '6',
      name: 'Sat',
    },
    {
      id: 'sunday',
      value: '0',
      name: 'Sun',
    },
  ],
  RU: [
    {
      id: 'Понедельник',
      value: '1',
      name: 'Пн',
    },
    {
      id: 'Вторник',
      value: '2',
      name: 'Вт',
    },
    {
      id: 'Среда',
      value: '3',
      name: 'Ср',
    },
    {
      id: 'Четверг',
      value: '4',
      name: 'Чт',
    },
    {
      id: 'Пятница',
      value: '5',
      name: 'Пт',
    },
    {
      id: 'Суббота',
      value: '6',
      name: 'Сб',
    },
    {
      id: 'Воскресенье',
      value: '0',
      name: 'Вс',
    },
  ],
  DE: [
    {
      id: 'Montag',
      value: '1',
      name: 'Mo',
    },
    {
      id: 'Dienstag',
      value: '2',
      name: 'Di',
    },
    {
      id: 'Mittwoch',
      value: '3',
      name: 'Mi',
    },
    {
      id: 'Donnerstag',
      value: '4',
      name: 'Do',
    },
    {
      id: 'Freitag',
      value: '5',
      name: 'Fr',
    },
    {
      id: 'Samstag',
      value: '6',
      name: 'Sa',
    },
    {
      id: 'Sonntag',
      value: '0',
      name: 'So',
    },
  ],
};

export const DATE_PLACEHOLDER = {
  UA: 'ДД.ММ.РРРР',
  EN: 'DD.MM.YYYY',
  RU: 'ДД.ММ.ГГГГ',
  DE: 'TT.MM.JJJJ',
};

export const LANGUAGE_CODES = {
  UA: 'uk-UA',
  EN: 'en-US',
  RU: 'ru-RU',
  DE: 'de-DE',
};
export const LABEL = {
  UA: {
    WILL_BE_REMOVED_LABEL: 'Буде видалена',
    WILL_BE_CREATED_LABEL: 'Буде створена',
  },
  EN: {
    WILL_BE_REMOVED_LABEL: 'Will be removed',
    WILL_BE_CREATED_LABEL: 'Will be created',
  },
  RU: {
    WILL_BE_REMOVED_LABEL: 'Будет удалена',
    WILL_BE_CREATED_LABEL: 'Будет создана',
  },
  DE: {
    WILL_BE_REMOVED_LABEL: 'Wird entfernt werden',
    WILL_BE_CREATED_LABEL: 'Wird erstellt werden',
  },
};
